export default "/corgi/pageapps/purchase/_next/static/media/apple.48dcc2ac.svg";